export type NavigatorSection =
  | "files"
  | "agent"
  | "settings"
  | "inputs"
  | "docs";

export const DEFAULT_NAVIGATOR_SECTION: NavigatorSection = "files";

export const NAVIGATOR_SECTIONS: NavigatorSection[] = [
  "files",
  "agent",
  "settings",
  "inputs",
  "docs",
];
